(() => {
  'use strict';
  const storageKey = 'fr_recent_fragrances_v1';
  const handlePattern = /^[a-z0-9][a-z0-9-]*$/;
  const currentProduct = document.currentScript?.dataset.frViewedProduct;
  const readHistory = () => {
    try {
      const history = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(history) ? [...new Set(history.filter(value => typeof value === 'string' && handlePattern.test(value)))].slice(0, 20) : [];
    } catch { return []; }
  };
  if (currentProduct && handlePattern.test(currentProduct)) {
    try { localStorage.setItem(storageKey, JSON.stringify([currentProduct, ...readHistory().filter(handle => handle !== currentProduct)].slice(0, 20))); } catch {}
  }
  const cardCache = new Map();
  function setupTabs(root) {
    if (root.dataset.frTabsReady) return;
    root.dataset.frTabsReady = 'true';
    const tablist = root.querySelector('[role="tablist"]');
    const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[data-fr-tab-panel]'));
    if (tabs.length < 2) return;
    tablist.hidden = false;
    const select = tab => {
      tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
      panels.forEach(panel => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        if (!panel.hidden) {
          root.querySelectorAll('.fr-home-bestsellers__view-all').forEach(link => {
            link.href = panel.dataset.frCollectionUrl;
            const label = link.querySelector('span');
            if (label) label.textContent = tab.textContent === 'All' ? 'Shop all bestsellers' : `Shop ${tab.textContent.toLowerCase()}’s bestsellers`;
          });
          panel.querySelector('.fr-home-bestsellers__viewport')?.scrollTo({left: 0});
        }
      });
      if (window.AOS) window.AOS.refreshHard();
      window.dispatchEvent(new Event('resize'));
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); select(tabs[next]); tabs[next].focus();
      });
    });
  }
  function setupFinder(root) {
    if (root.dataset.frFinderReady || !window.FRFragranceSearch) return;
    root.dataset.frFinderReady = 'true';
    const {products, score} = window.FRFragranceSearch;
    const form = root.querySelector('form');
    const input = form.querySelector('input[type="search"]');
    const results = root.querySelector('.fr-home-finder__results');
    const feedback = root.querySelector('.fr-home-finder__feedback');
    const status = root.querySelector('[data-fr-finder-status]');
    const empty = root.querySelector('[data-fr-finder-empty]');
    const all = root.querySelector('[data-fr-finder-all]');
    const shortcuts = Array.from(root.querySelectorAll('[data-fr-finder-query]'));
    const normalise = value => String(value || '').trim().toLowerCase();
    let expanded = false;
    let timer;
    function styleScore(product, query) {
      const descriptors = `${(product.tags || []).join(' ')} ${product.family || ''} ${product.scent_style || ''}`.toLowerCase();
      if (query === 'floral') return /\b(floral|florals|rose)\b/.test(descriptors) ? 500 : 0;
      if (query === 'citrus') return /\bcitrus\b/.test(descriptors) ? 500 : 0;
      if (query === 'fresh') return /\b(fresh|clean|aquatic|citrus)\b/.test(descriptors) ? 500 : 0;
      return score(product, query);
    }
    function find(query, kind) {
      const normal = normalise(query);
      const style = kind === 'style' || shortcuts.some(button => button.dataset.frFinderKind === 'style' && normalise(button.dataset.frFinderQuery) === normal);
      return products.filter(product => product.available).map(product => ({product, relevance: style ? styleScore(product, normal) : score(product, query)})).filter(item => item.relevance > 0).sort((a, b) => b.relevance - a.relevance || a.product.title.localeCompare(b.product.title));
    }
    shortcuts.forEach(button => {
      button.hidden = button.dataset.frWhenAvailable === 'true' && find(button.dataset.frFinderQuery, button.dataset.frFinderKind).length === 0;
      button.addEventListener('click', () => {
        clearTimeout(timer); expanded = false;
        input.value = normalise(input.value) === normalise(button.dataset.frFinderQuery) ? '' : button.dataset.frFinderQuery;
        render();
      });
    });
    function render() {
      const query = input.value.trim();
      results.replaceChildren();
      shortcuts.forEach(button => button.setAttribute('aria-pressed', String(normalise(button.dataset.frFinderQuery) === normalise(query))));
      if (!query) { feedback.hidden = results.hidden = empty.hidden = all.hidden = true; return; }
      const matches = find(query);
      feedback.hidden = false; results.hidden = !matches.length; empty.hidden = matches.length > 0;
      const shown = expanded ? matches : matches.slice(0, 6);
      status.textContent = matches.length > shown.length ? `Showing ${shown.length} of ${matches.length} fragrances for “${query}”` : `${matches.length} ${matches.length === 1 ? 'fragrance' : 'fragrances'} found for “${query}”`;
      shown.forEach(({product}) => {
        const link = document.createElement('a'); link.className = 'fr-home-finder__result'; link.href = product.url;
        if (product.image) { const image = document.createElement('img'); image.src = product.image; image.width = image.height = 88; image.alt = ''; image.loading = 'lazy'; link.append(image); }
        const copy = document.createElement('span'); copy.className = 'fr-home-finder__result-copy';
        const title = document.createElement('strong'); title.textContent = product.title;
        const inspiration = document.createElement('span'); inspiration.textContent = `Inspired by ${product.inspiration}`;
        copy.append(title, inspiration);
        const notes = String(product.notes || '').split(/[,;|]+/).map(note => note.trim()).filter(Boolean).slice(0, 3).join(' · ');
        if (notes) { const detail = document.createElement('small'); detail.textContent = notes; copy.append(detail); }
        link.append(copy); results.append(link);
      });
      all.hidden = matches.length <= 6;
      all.textContent = expanded ? 'Show fewer fragrances' : `Show all ${matches.length} fragrances`;
      all.setAttribute('aria-expanded', String(expanded));
    }
    input.addEventListener('input', () => { clearTimeout(timer); expanded = false; timer = setTimeout(render, 160); });
    form.addEventListener('submit', event => { event.preventDefault(); clearTimeout(timer); expanded = false; render(); });
    all.addEventListener('click', () => { expanded = !expanded; render(); });
    root.querySelector('[data-fr-finder-clear]').addEventListener('click', () => { clearTimeout(timer); expanded = false; input.value = ''; render(); input.focus(); });
  }
  async function setupRecent(root) {
    const history = readHistory();
    const signature = JSON.stringify(history);
    if (root.dataset.frRecentHistory === signature) return;
    root.dataset.frRecentHistory = signature;
    const grid = root.querySelector('[data-fr-recent-grid]');
    grid.replaceChildren();
    root.hidden = true;
    if (!history.length) return;
    const catalogueNode = document.getElementById('FRSearchCatalogue');
    let catalogue = [];
    try { catalogue = JSON.parse(catalogueNode?.textContent || '[]'); } catch {}
    const eligible = new Set(catalogue.filter(product => product.available).map(product => product.handle));
    const handles = history.filter(handle => eligible.has(handle)).slice(0, 4);
    await Promise.all(handles.map(async handle => {
      if (cardCache.has(handle)) return;
      try {
        const base = window.Shopify?.routes?.root || '/';
        const url = new URL(`${base}products/${encodeURIComponent(handle)}`, location.origin);
        url.searchParams.set('section_id', 'fr-home-recent-card');
        const previewId = new URL(location.href).searchParams.get('preview_theme_id');
        if (previewId) url.searchParams.set('preview_theme_id', previewId);
        const response = await fetch(url, {credentials: 'same-origin'});
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const card = doc.querySelector('.grid__item');
        if (card) { card.querySelectorAll('style, script').forEach(node => node.remove()); cardCache.set(handle, card); }
      } catch {}
    }));
    if (!root.isConnected || root.dataset.frRecentHistory !== signature) return;
    handles.forEach(handle => { const card = cardCache.get(handle); if (card) grid.append(document.importNode(card, true)); });
    if (!grid.children.length) return;
    root.hidden = false;
    if (window.AOS) window.AOS.refreshHard();
  }
  function boot() {
    document.querySelectorAll('[data-fr-home-tabs]').forEach(setupTabs);
    document.querySelectorAll('[data-fr-home-finder]').forEach(setupFinder);
    document.querySelectorAll('[data-fr-home-recent]').forEach(setupRecent);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('pageshow', boot);
})();


